module.exports = __webpack_public_path__ + "img/katycorso.5ad53b36.png";